import type { ApiRedirectResult } from '../../api/types/payments.types';

/**
 * The ONLY place that knows how to navigate to the provider's hosted page
 * (PaySpot isolation point — fe-plan §2.3): when the PaySpot sandbox
 * arrives, only this helper (+ messages) changes.
 *
 * - Stripe: `formFields` absent → plain redirect to `redirectUrl`.
 * - PaySpot: `formFields` present → hidden `<form method="POST">` to
 *   `redirectUrl` with hidden fields, auto-submit (hosted requires form-POST).
 */
export function startProviderRedirect(result: ApiRedirectResult) {
  if (!result.formFields) {
    window.location.assign(result.redirectUrl);
    return;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = result.redirectUrl;
  form.style.display = 'none';

  for (const [name, value] of Object.entries(result.formFields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
